module.exports = __webpack_public_path__ + "media/images/swifticons/thumbs-up-icon-340cec701a88bc1641ecc9540d493f9f.png";